import type { PageExperience } from '@/features/experiences/types';
import { FONT_HEADING } from '../../../css/customFonts';
import { getStyleById } from '../../../theme';

type Props = {
  dayOfWeek: number;
  experience: PageExperience;
};

const DAY_LABELS: Record<number, string> = {
  1: 'Sun',
  2: 'Mon',
  3: 'Tue',
  4: 'Wed',
  5: 'Thu',
  6: 'Fri',
  7: 'Sat',
};

export const DayHeader = ({ dayOfWeek, experience }: Props) => {
  const theme = getStyleById(experience.styleId ?? undefined);

  return (
    <div
      style={{
        fontFamily: FONT_HEADING,
        fontSize: '0.75em',
        fontWeight: '700',
        textAlign: 'center',
        padding: '0.3em 0',
        textTransform: 'uppercase',
        color: theme.textColor || '#000000',
        backgroundColor: theme.accentColor || '#F0F0F0',
      }}
    >
      {DAY_LABELS[dayOfWeek]}
    </div>
  );
};
